import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const weekDays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

const WeekDaysHeader = ({ classes }) => {
  const renderCell = (weekDay, idx) => {
    return (
      <Box className={classes.placeCenter} key={idx}>
        <Typography className={classes.weekDay}>{weekDay}</Typography>
      </Box>
    );
  };

  return <Box className={classes.weekDays}>{weekDays.map(renderCell)}</Box>;
};

export default WeekDaysHeader;
